<script>
    import {
        goBack,
        store,
        triggerValidation,
        isDisabled,
    } from '../../Store.svelte';
    import { onMount } from 'svelte';
    import { navigate, link } from 'svelte-routing';
    import {
        formValidation,
        accountDetailsFields,
    } from '../../Validators.svelte';
    import { sendCode } from '../../clients/CodeClient.svelte';
    import Preloader from '../../components/Preloader.svelte';
    import { env } from '../../Environment.svelte';

    if ($store.requestedServices.productId == null) {
        navigate('/comparador', { replace: false });
    }
    let isLoading = false;
    let loadingMessage = '';

    const isSky = $store.requestedServices.isSky;
    const tabsStyle = `--dynamic-rgba: ${isSky ? 'rgba(4, 8, 255, 0.342)' : 'rgba(211, 23, 114, 0.1)'};
                       --dynamic-color: ${isSky ? '#000ff5' : '#d31772'};`;
    $: isForeign = false;
    $: isValidPassportError = false;
    $: isValidCurpError = false;

    let focusedField = '';

    let processAdvanced = !!$store.purchaseStatus.accountNumber;

    const handleIsForeign = () => {
        if (isForeign) {
            $store.personalDetails.curp = '';
            $store.personalDetails.isForeign = false;
        } else {
            $store.personalDetails.pasaporte = '';
            $store.personalDetails.isForeign = true;
        }

        $store.personalDetails.isForeign = isForeign;
    };

    let valField = (fieldName) => {
        formValidation(fields, $store.personalDetails, fieldName, {
            shouldFocus: false,
        });
        fields = fields;
    };

    let valContent = async () => {
        const formData = {
            nombre: $store.personalDetails.nombre,
            apPaterno: $store.personalDetails.apPaterno,
            apMaterno: $store.personalDetails.apMaterno,
            numeroCelular: $store.personalDetails.numeroCelular,
            correo: $store.personalDetails.correo,
            isForeign: $store.personalDetails.isForeign,
        };

        if (isForeign) {
            formData.pasaporte = $store.personalDetails.pasaporte;
            isValidPassportError = $store.personalDetails.pasaporte.length < 1;
        } else {
            formData.curp = $store.personalDetails.curp;
            isValidCurpError = $store.personalDetails.curp.length < 1;
        }

        let valid = formValidation(fields, formData, null);
        fields = fields;

        if (
            valid &&
            ((!isValidCurpError && !isForeign) ||
                (!isValidPassportError && isForeign))
        ) {
            try {
                isLoading = true;
                loadingMessage =
                    'Estamos procesando tu solicitud. Esto solo tomará unos momentos.';
                if (processAdvanced) {
                    navigate('/compra/direccion', { replace: false });
                } else {
                    navigate('/compra/verificacion', { replace: false });
                }
            } catch (error) {
                console.error('Error:', error);
            } finally {
                isLoading = false;
            }
        }
    };

    $: {
        if ($goBack) {
            navigate('/compra/entrega', { replace: false });
            goBack.set(false);
        }

        if ($triggerValidation) {
            valContent();
            triggerValidation.set(false);
        }
    }

    onMount(() => {
        window.document.dispatchEvent(
            new Event('DOMContentLoaded', {
                bubbles: true,
                cancelable: true,
            })
        );
        $store.settings.location = { progress: 35, step: 2 };
    });

    let fields = accountDetailsFields;
    let termsAccepted = false;
    $: isDisabled.set(termsAccepted);
</script>

<div>
    <div class="pure-g justify-content-center">
        <div class="pure-u-1 pure-u-lg-2-3">
            <div class="pure-g align-items-center">
                <div class="pure-u-1 sm-m-b-20">
                    <h1 class="text-fs-16 m-b-25">
                        Proporciona los siguientes datos para configurar al
                        titular de la cuenta y personalizar tu paquete.
                    </h1>
                </div>
            </div>
            <div class="panel m-b-30">
                {#if isLoading}
                    <div class="small-loader">
                        <Preloader status={loadingMessage} />
                    </div>
                {:else}
                    <p
                        class="fw-semibold d-flex justify-content-between align-items-center m-b-12 text-fs-15"
                    >
                        Datos del titular

                        <span>
                            Es cliente extranjero
                            <span
                                class="checkbox-switch m-l-5"
                                style={tabsStyle}
                            >
                                <input
                                    bind:checked={isForeign}
                                    on:change={handleIsForeign}
                                    disabled={processAdvanced}
                                    type="checkbox"
                                    name="isForeign"
                                    id="isForeign"
                                />
                                <label for="isForeign" />
                            </span>
                        </span>
                    </p>
                    <div class="pure-g">
                        <div class="pure-u-1 pure-u-sm-1-2">
                            <div
                                class="ctrl-holder m-b-20 {fields.nombre.error
                                    ? 'error'
                                    : ''}
                                    {focusedField === 'nombre' ? 'focused' : ''}
                                    {$store.personalDetails.nombre
                                    ? 'filled'
                                    : ''}"
                            >
                                <label
                                    for="nombre"
                                    class="placeholder text-fs-15 disabled"
                                    >Nombres</label
                                >

                                <input
                                    type="text"
                                    name="nombre"
                                    id="nombre"
                                    disabled={processAdvanced}
                                    required
                                    on:focus={() => (focusedField = 'nombre')}
                                    on:blur={() => (focusedField = '')}
                                    on:input={() => valField('nombre')}
                                    on:change={() => valField('nombre')}
                                    bind:value={$store.personalDetails.nombre}
                                />
                                {#if fields.nombre.error}
                                    <label class="error" for="nombre"
                                        >{fields.nombre.errorMessage}</label
                                    >
                                {/if}
                            </div>
                        </div>
                        <div class="pure-u-1 pure-u-sm-1-2">
                            <div
                                class="ctrl-holder m-b-20 {fields.apPaterno
                                    .error
                                    ? 'error'
                                    : ''}
                                    {focusedField === 'apPaterno'
                                    ? 'focused'
                                    : ''}
                                    {$store.personalDetails.apPaterno
                                    ? 'filled'
                                    : ''}"
                            >
                                <label
                                    for="apPaterno"
                                    class="placeholder text-fs-15"
                                    >Apellido paterno</label
                                >
                                <input
                                    type="text"
                                    name="apPaterno"
                                    id="apPaterno"
                                    disabled={processAdvanced}
                                    required
                                    on:focus={() =>
                                        (focusedField = 'apPaterno')}
                                    on:blur={() => (focusedField = '')}
                                    on:input={() => valField('apPaterno')}
                                    on:change={() => valField('apPaterno')}
                                    bind:value={
                                        $store.personalDetails.apPaterno
                                    }
                                />
                                {#if fields.apPaterno.error}
                                    <label class="error" for="apPaterno"
                                        >{fields.apPaterno.errorMessage}</label
                                    >
                                {/if}
                            </div>
                        </div>
                        <div class="pure-u-1 pure-u-sm-1-2">
                            <div
                                class="ctrl-holder m-b-20 {fields.apMaterno
                                    .error
                                    ? 'error'
                                    : ''}
                                    {focusedField === 'apMaterno'
                                    ? 'focused'
                                    : ''}
                                    {$store.personalDetails.apMaterno
                                    ? 'filled'
                                    : ''}"
                            >
                                <label
                                    for="apMaterno"
                                    class="placeholder text-fs-15"
                                    >Apellido materno</label
                                >
                                <input
                                    type="text"
                                    name="apMaterno"
                                    id="apMaterno"
                                    disabled={processAdvanced}
                                    required
                                    on:input={() => valField('apMaterno')}
                                    on:change={() => valField('apMaterno')}
                                    on:focus={() =>
                                        (focusedField = 'apMaterno')}
                                    on:blur={() => (focusedField = '')}
                                    bind:value={
                                        $store.personalDetails.apMaterno
                                    }
                                />
                                {#if fields.apMaterno.error}
                                    <label class="error" for="apMaterno"
                                        >{fields.apMaterno.errorMessage}</label
                                    >
                                {/if}
                            </div>
                        </div>
                        <div class="pure-u-1 pure-u-sm-1-2">
                            <div
                                class="ctrl-holder m-b-20 {fields.numeroCelular
                                    .error
                                    ? 'error'
                                    : ''}
                                    {focusedField === 'numeroCelular'
                                    ? 'focused'
                                    : ''}
                                    {$store.personalDetails.numeroCelular
                                    ? 'filled'
                                    : ''}"
                            >
                                <label
                                    for="numeroCelular"
                                    class="placeholder disabled"
                                    >Número de teléfono</label
                                >
                                <input
                                    type="text"
                                    name="numeroCelular"
                                    id="numeroCelular"
                                    disabled={processAdvanced}
                                    required
                                    bind:value={
                                        $store.personalDetails.numeroCelular
                                    }
                                    on:change={() => valField('numeroCelular')}
                                    on:input={() => valField('numeroCelular')}
                                    on:focus={() =>
                                        (focusedField = 'numeroCelular')}
                                    on:blur={() => (focusedField = '')}
                                />
                                {#if fields.numeroCelular.error}
                                    <label class="error" for="numeroCelular"
                                        >{fields.numeroCelular
                                            .errorMessage}</label
                                    >
                                {/if}
                            </div>
                        </div>
                        {#if !isForeign}
                            <div class="pure-u-1 pure-u-sm-1-2">
                                <div
                                    class="ctrl-holder m-b-20 {fields.curp.error
                                        ? 'error'
                                        : ''}
                                    {focusedField === 'curp' ? 'focused' : ''}
                                    {$store.personalDetails.curp
                                        ? 'filled'
                                        : ''}"
                                >
                                    <label
                                        for="curp"
                                        class="placeholder disabled">CURP</label
                                    >
                                    <input
                                        type="text"
                                        name="curp"
                                        id="curp"
                                        disabled={processAdvanced}
                                        required={!$store.personalDetails
                                            .isForeign}
                                        oninput="this.value = this.value.toUpperCase()"
                                        bind:value={$store.personalDetails.curp}
                                        on:input={() => valField('curp')}
                                        on:change={() => valField('curp')}
                                        on:focus={() => (focusedField = 'curp')}
                                        on:blur={() => (focusedField = '')}
                                    />
                                    {#if fields.curp.error || isValidCurpError}
                                        <label class="error" for="curp"
                                            >{fields.curp.errorMessage}</label
                                        >
                                    {/if}
                                </div>
                            </div>
                        {:else}
                            <div class="pure-u-1 pure-u-sm-1-2">
                                <div
                                    class="ctrl-holder m-b-20 {fields.pasaporte
                                        .error
                                        ? 'error'
                                        : ''}
                                    {focusedField === 'pasaporte'
                                        ? 'focused'
                                        : ''}
                                    {$store.personalDetails.pasaporte
                                        ? 'filled'
                                        : ''}"
                                >
                                    <label
                                        for="pasaporte"
                                        class="placeholder disabled"
                                        >Pasaporte o Licencia</label
                                    >
                                    <input
                                        type="text"
                                        name="pasaporte"
                                        id="pasaporte"
                                        disabled={processAdvanced}
                                        required={$store.personalDetails
                                            .isForeign}
                                        oninput="this.value = this.value.toUpperCase()"
                                        bind:value={
                                            $store.personalDetails.pasaporte
                                        }
                                        on:change={() => valField('pasaporte')}
                                        on:input={() => valField('pasaporte')}
                                        on:focus={() =>
                                            (focusedField = 'pasaporte')}
                                        on:blur={() => (focusedField = '')}
                                    />
                                    {#if fields.pasaporte.error || isValidPassportError}
                                        <label class="error" for="curp"
                                            >{fields.pasaporte
                                                .errorMessage}</label
                                        >
                                    {/if}
                                </div>
                            </div>
                        {/if}
                        {#if $store.requestedServices.product.categoriapaquete === 'NEGOCIOSMODULAR'}
                            <div class="pure-u-1 pure-u-sm-1-2">
                                <div
                                    class="select-holder {fields.giroNegocio
                                        .error
                                        ? 'error'
                                        : ''}"
                                >
                                    <select
                                        name="giroNegocio"
                                        id="giroNegocio"
                                        disabled={processAdvanced}
                                        bind:value={
                                            $store.personalDetails.giroNegocio
                                        }
                                    >
                                        <option value=""
                                            >Selecciona el giro de tu negocio</option
                                        >
                                        <option value="Residencial"
                                            >Residencial</option
                                        >
                                        <option value="Comercio"
                                            >Comercio</option
                                        >
                                        <option value="Hoteles y Restaurantes"
                                            >Hoteles y Restaurantes</option
                                        >
                                        <option value="Servicios Profesionales"
                                            >Servicios Profesionales</option
                                        >
                                        <option value="Educativos"
                                            >Educativos</option
                                        >
                                        <option value="Salud">Salud</option>
                                        <option value="Gobierno"
                                            >Gobierno</option
                                        >
                                        <option value="Otros">Otros</option>
                                    </select>
                                    {#if fields.giroNegocio.error}
                                        <label class="error" for="giroNegocio"
                                            >{fields.giroNegocio
                                                .errorMessage}</label
                                        >
                                    {/if}
                                </div>
                            </div>
                            <div class="pure-u-1 pure-u-sm-1-2">
                                <div
                                    class="ctrl-holder m-b-20 {fields
                                        .razonSocial.error
                                        ? 'error'
                                        : ''}
                                    {focusedField === 'razonSocial'
                                        ? 'focused'
                                        : ''}
                                    {$store.personalDetails.razonSocial
                                        ? 'filled'
                                        : ''}"
                                >
                                    <label for="razonSocial" class="placeholder"
                                        >Razón social</label
                                    >
                                    <input
                                        type="text"
                                        name="razonSocial"
                                        id="razonSocial"
                                        disabled={processAdvanced}
                                        bind:value={
                                            $store.personalDetails.razonSocial
                                        }
                                        on:change={() =>
                                            valField('razonSocial')}
                                        on:input={() => valField('razonSocial')}
                                        on:focus={() =>
                                            (focusedField = 'razonSocial')}
                                        on:blur={() => (focusedField = '')}
                                    />
                                    {#if fields.razonSocial.error}
                                        <label class="error" for="nombre"
                                            >{fields.razonSocial
                                                .errorMessage}</label
                                        >
                                    {/if}
                                </div>
                            </div>
                        {/if}
                    </div>
                    <p
                        class="fw-semibold d-flex justify-content-between align-items-center m-b-10 text-fs-15"
                    >
                        Datos de tu cuenta
                    </p>
                    <div class="pure-g">
                        <div class="pure-u-1">
                            <div
                                class="ctrl-holder m-b-20 {fields.correo.error
                                    ? 'error'
                                    : ''}
                                    {focusedField === 'correo' ? 'focused' : ''}
                                    {$store.personalDetails.correo
                                    ? 'filled'
                                    : ''}"
                            >
                                <label for="correo" class="placeholder"
                                    >Correo electrónico</label
                                >
                                <input
                                    type="email"
                                    name="correo"
                                    id="correo"
                                    disabled={processAdvanced}
                                    required
                                    on:input={() => valField('correo')}
                                    bind:value={$store.personalDetails.correo}
                                    on:change={() => valField('correo')}
                                    on:focus={() => (focusedField = 'correo')}
                                    on:blur={() => (focusedField = '')}
                                />
                                {#if fields.correo.error}
                                    <label class="error" for="correo"
                                        >{fields.correo.errorMessage}</label
                                    >
                                {/if}
                            </div>
                        </div>
                    </div>
                    <div class="pure-g">
                        <div class="pure-u-1">
                            <div class="d-flex align-items-center">
                                <label class="custom-checkbox">
                                    <input
                                        type="checkbox"
                                        name="terminos"
                                        id="terminos"
                                        bind:checked={termsAccepted}
                                    />
                                    <span class="check-icon">
                                        <img
                                            src="/assets/img/icons/check-icon.svg"
                                            alt="check"
                                        />
                                    </span>
                                </label>
                                <label
                                    for="terminos"
                                    class="m-l-10 text-fs-13 fw-regular"
                                >
                                    acepto los <a
                                        href={env.dev.urlIzziTerms}
                                        class="text-decoration-link"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        >terminos y condiciones de uso</a
                                    >
                                </label>
                            </div>
                        </div>
                    </div>

                    <div
                        class="d-flex align-items-center justify-content-between"
                    >
                        <a use:link href="/compra/configura" class="back-link">
                            <svg class="icon" aria-hidden="true">
                                <use
                                    xlink:href="/assets/img/icons/symbol-defs.svg#icon-arrow-left"
                                />
                            </svg>
                            <span>atrás</span>
                        </a>
                        <div>
                            <a
                                href="#/"
                                class="pure__button button-hide {termsAccepted &&
                                !isLoading
                                    ? 'pure__button--base'
                                    : 'pure__button--disabled'}"
                                on:click|preventDefault={() =>
                                    termsAccepted && !isLoading && valContent()}
                            >
                                Continuar
                            </a>
                        </div>
                    </div>
                {/if}
            </div>
        </div>
    </div>
</div>
